const { color } = require("./log-colors");

module.exports = res => {
  if (!res.ok) {
    const msg = `${res.method || "POST"} ${res.url} failed — status ${res.status} (${res.statusText || "no status text"})`;
    console.error(color.red(msg));
    throw Error(msg);
  }
  if (res.status === 204) {
    console.warn(
      color.yellow(`${res.method || "POST"} ${res.url} returned 204 No Content — the resource exists but has no data`),
    );
    return Promise.resolve(null);
  }
  return res.json();
};
